export const headerTitle = 'Your Preferred Agent';
export const headerText = `We noticed you have worked with another agent at one time. Please select your preferred agent from the list below and we'll update our records.`;
export const headerIconAlt = 'An image with a tick sign symbol';
export const buttonLabel = 'Select Agent';
export const plansButtonLabel = 'Save';
